const API = process.env.REACT_APP_BACKEND_URL;

export const mcPost = async (path, body) => {
  const r = await fetch(`${API}/api/menu-costing/${path}`, {
    method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body),
  });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.detail || "Request failed");
  return d;
};

export const mcDownload = async (body) => {
  const r = await fetch(`${API}/api/menu-costing/report`, {
    method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body),
  });
  if (!r.ok) throw new Error((await r.json().catch(() => ({}))).detail || "Export failed");
  const blob = await r.blob();
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `menu_costing_${body.report}_${body.center}.${body.format}`;
  a.click();
  URL.revokeObjectURL(a.href);
};

export const money = (v, cur = "₹") => (v === null || v === undefined ? "—" : `${cur}${Number(v).toFixed(2)}`);
export const pct = (v) => (v === null || v === undefined ? "—" : `${Number(v).toFixed(1)}%`);

export const ALERT_STYLE = {
  GREEN: "bg-emerald-100 text-emerald-800 border-emerald-300",
  AMBER: "bg-amber-100 text-amber-800 border-amber-300",
  RED: "bg-red-100 text-red-800 border-red-300",
  GREY: "bg-stone-100 text-stone-600 border-stone-300",
};

export const REPORTS = [
  ["costing", "Centre-wise Menu Costing"], ["price_list", "Menu Selling Price List"],
  ["high_food_cost", "High Food Cost Items"], ["low_margin", "Low Margin Items"],
  ["ingredient_price_changes", "Ingredient Price Changes"], ["wastage_cost", "Wastage Cost"],
  ["suggested_price_changes", "Suggested Price Changes"], ["missing_data", "Missing Recipe / Purchase Rate"],
];
